import styled from 'styled-components';
import StarJedi1 from '../../Assets/Font/Star_Jedi/starjedi/Starjedi.ttf';



export const Container = styled.div`
    align-items: stretch;
    display: flex;
    justify-content: center;
    width: 100%;
    height: 120%;
    background-color: #00384a;
    @font-face {
        font-family: "StarJedi1";
        src: url(${StarJedi1});
    }
`;
export const Checkbox1 = styled.div`
    font-family: 'Roboto', sans-serif;
    font-size: 12px;
    color: #ffffff;
    margin-bottom: 10px;
`

export const Form = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    place-content: center;
    width: 100%;
    height: 100vh;
    overflow: auto;
    h1{
        margin: 35px 0px 0px 0px;
        font-family: 'Roboto',sans-serif;
        font-weight: 500;
        font-size: 25px;
        text-justify: auto;
        color: #ffffff;
        text-align: center;
        width: 286px;
        height: 24px;
    }
    h2{
        margin: 0px;
        font-family: 'Roboto',sans-serif;
        font-weight: 500;
        font-size: 12px;
        text-justify: auto;
        color: #ffffff;
        text-align: center;
        width: 286px;
        height: 24px;
    }
    h3{
        font-size: 25px;
        margin-right: -100px;
        font-family: "StarJedi1";
        font-weight: 200;
        color: #ffffff
    }
    h6 {
        margin: 35px 0px 35px 0px;
        font-family: 'Roboto',sans-serif;
        font-weight: 400;
        font-size: 14px;
        text-justify: auto;
        color: #ffffff;
        text-align: center;
        width: 286px;
        height: 24px;
    }
    #Submit{
        margin-top: 24px;
        padding: 0px 16px;
        width: 286px;
        height: 40px;
        background-color: #2F855A;
        border: 0px;
        border-radius: 5px;
        font-family: 'Roboto',sans-serif;
        font-size: 16px;
        font-weight: 500;
        color: #ffffff;
    }
    #Submit:hover{
        background-color: #234E52;
        transition-duration: 0.2s;
    }
    #NovaSenha{
        margin: 0px 0px 0px 0px;
        padding: 0px 30px 0px 12px;
        width: 286px;
        height: 32px;
        background-color: #065666 ;
        border: 0px;
        border-radius: 5px;
        color: #ffffff;
    }
    #NovaSenha:hover{
        background-color: #086F83;
        transition-duration: 0.2s;
    }
    #NovaSenha:focus{
        background-color: transparent;
        outline-color: #38A169;
        border: 0px none;
    }
    #ConfirmaçãoSenha{
        margin: 30px 0px 0px 0px;
        padding: 0px 30px 0px 12px;
        width: 286px;
        height: 32px;
        background-color: #065666 ;
        border: 0px;
        border-radius: 5px;
        color: #ffffff;
    }
    #ConfirmaçãoSenha:hover{
        background-color: #086F83;
        transition-duration: 0.2s;
    }
    #ConfirmaçãoSenha:focus{
        background-color: transparent;
        outline-color: #38A169;
        border: 0px none;
    }
    input::-webkit-input-placeholder{
    color: #ffffff;
    font-family: "Roboto" sans-serif;
    font-size: 14px;
    }
    input:-webkit-autofill {
        box-shadow: 0 0 0 30px #065666 inset; //-webkit-box-shadow: 0 0 0 30px #065666 inset;
    }   
    input:-webkit-autofill {
        -webkit-text-fill-color: #ffffff !important;
    }
`;
